import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { API_SERVER_FILES } from '../../config';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { SpliUrl } from '../../Utils/utils';

// import axios from '../../Api/axios';
// const deleteFile = (setFiles, id) => {
//     axios.delete('craUpload/deleteFile' + '/' + `${id}`).then(
//         (res) => {
//             console.log(res.data);

//             setFiles((f) => f.filter((f) => f._id !== res.data.id));
//         },
//         () => {
//             console.error('error in deleting file');
//         }
//     );
// };
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'file',
        numeric: false,
        disablePadding: false,
        label: 'Fichiers',
        width:'70%'
    },
    {
        id: 'info',
        numeric: false,
        disablePadding: false,
        label: '',
        width:'20%'
    },

];

function EnhancedTableHead({order, orderBy,mode, onRequestSort}) {
    //mode : readOnly
    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        mode:PropTypes.any, // le cas readOnly on masque la colonne corbeille
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    console.log('mode mode',mode);
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {mode!='readOnly' &&
                    <TableCell
                        style={{
                            backgroundColor: '#E3E6EA',
                            borderRadius: '10px 0px 0px 0px',
                        }}
                    ></TableCell>
                }
                {headCells.map((headCell) => (
                    <TableCell
                        style={{ backgroundColor: '#E3E6EA',width:headCell.width, borderRadius: '0px  0px' }}
                        key={headCell.id}
                        align={headCell.numeric ? 'left' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box
                                    component="span"
                                    sx={visuallyHidden}
                                >
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

export default function FileList({ list, setlist,mode}) {
    //mode : readOnly -> on l'adopte pour masquer la corbeille si on est expert ou admin dans la partie crax
    FileList.propTypes = {
        list: PropTypes.array,
        setlist: PropTypes.func,
        mode:PropTypes.any,
        onClickOut: PropTypes.func,
    };

    // console.log('hiii',list);
    // const list = [
    //     {
    //         __v: 0,
    //         _id: '63643a0e0c482b3bc45eeb03',
    //         createdAt: '2022-11-03T22:00:46.326Z',
    //         idCra: '636436a104d6c7354033ceae',
    //         name: '111111.png',
    //         path: '/uploads/1667512846309-111111.png',
    //         updatedAt: '2022-11-03T22:00:46.326Z',
    //     },
    //     {
    //         __v: 0,
    //         _id: '63643a210c482b3bc45eeb9e',
    //         createdAt: '2022-11-03T22:01:05.195Z',
    //         idCra: '636436a104d6c7354033ceae',
    //         name: 'CV_ang.pdf',
    //         path: '/uploads/1667512865142-cv_ang.pdf',
    //         updatedAt: '2022-11-03T22:01:05.195Z',
    //     },
    //     {
    //         __v: 0,
    //         _id: '63c92ded7d29ef0afc4293fc',
    //         createdAt: '2023-01-19T11:47:57.633Z',
    //         idCra: '636436a104d6c7354033ceae',
    //         name: 'Exam-local-maths-coll-moulay-ismail-3ac-2019.pdf',
    //         path: '/uploads/1674128877572-exam-local-maths-coll-moulay-ismail-3ac-2019.pdf',
    //         updatedAt: '2023-01-19T11:47:57.633Z',
    //     }
    // ];

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(7);
    const { i18n } = useTranslation();
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    console.log('handleRequestSort',handleRequestSort);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = list.map((n) => n?.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>

                <TableContainer>
                    <Table
                        sx={{ width: '100%', height: '100%' }}
                        aria-labelledby="tableTitle"
                        //size={'small'}
                    >
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            mode={mode}
                            onSelectAllClick={handleSelectAllClick}
                        />
                        <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 list.slice().sort(getComparator(order, orderBy)) */}
                            {stableSort(list, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row?._id);

                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleClick(event, row?._id)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            // key={row?._id}
                                            key={index}
                                            selected={isItemSelected}
                                        >
                                            {mode!='readOnly' &&
                                                <TableCell
                                                    style={{ width: '10%' }}
                                                    align="center"
                                                >
                                                    <IconButton
                                                        onClick={() => {
                                                            console.log(row);
                                                            // deleteFile(setlist, row?._id);
                                                            // setlist((f) => f.filter((f) => f._id !== res.data.id));
                                                            let index = list.indexOf(row);
                                                            if (index > -1) {
                                                                setlist(
                                                                    [
                                                                        ...list.slice(0, index),
                                                                        ...list.slice(index + 1, list.length),
                                                                    // list.splice(index, 1)
                                                                    ]
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            }

                                            <TableCell
                                                style={{ width: '70%'}}
                                                align="left"
                                            >
                                                {
                                                    row?.isFromBackend ?
                                                        <a
                                                            rel="noreferrer"
                                                            target="_blank"
                                                            href={API_SERVER_FILES + encodeURIComponent(row?.url)}
                                                            style={{margin:'0px'}}
                                                        >
                                                            {SpliUrl(row?.name)}
                                                        </a>
                                                        :
                                                        <p style={{margin:'0px'}}>{row?.name}</p>
                                                }
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                style={{ width: '20%' }}
                                            >
                                                <span style={{ color: '#1976D2' }}>{i18n.t('ajouté le :')} </span>
                                                <span style={{ color: '#4D5864' }}>
                                                    {' '}
                                                    {/* //* OLD {(row?.createdAt)?.split('T')[0]} */}
                                                    {row?.isFromBackend ? formatDateJJMMYYYY(row?.dateTelechargement) : formatDateJJMMYYYY(Date.now())}
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: 52 * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={list.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
